import { SearchCriteriaSortFieldEnum } from '../../../api/mentions/enum/search-criteria-sort-field.enum';
/* eslint-disable @typescript-eslint/naming-convention */
export enum MonitoringSortTypesEnum {
    published = 'published',
    available = 'available',
    audience = 'audience',
    relevancy = 'relevancy',
    engagement = 'engagements',
    engagement_rate = 'engagement_rate',
    domainAuthority = 'domainAuthority'
}

export const searchCriteriaSortFieldToMonitoringSortTypeMap: Map<SearchCriteriaSortFieldEnum, MonitoringSortTypesEnum> = new Map([
    [SearchCriteriaSortFieldEnum.published, MonitoringSortTypesEnum.published],
    [SearchCriteriaSortFieldEnum.indexed_date, MonitoringSortTypesEnum.available],
    [SearchCriteriaSortFieldEnum.audience_reach, MonitoringSortTypesEnum.audience],
    [SearchCriteriaSortFieldEnum.relevancy, MonitoringSortTypesEnum.relevancy],
    [SearchCriteriaSortFieldEnum.domainAuthority, MonitoringSortTypesEnum.domainAuthority],
    [SearchCriteriaSortFieldEnum.engagement_total, MonitoringSortTypesEnum.engagement],
    [SearchCriteriaSortFieldEnum.engagement_rate, MonitoringSortTypesEnum.engagement_rate],
]);

export const monitoringSortTypeToSearchCriteriaSortFieldMap: Map<MonitoringSortTypesEnum, SearchCriteriaSortFieldEnum> = new Map([
    [MonitoringSortTypesEnum.published, SearchCriteriaSortFieldEnum.published],
    [MonitoringSortTypesEnum.available, SearchCriteriaSortFieldEnum.indexed_date],
    [MonitoringSortTypesEnum.audience, SearchCriteriaSortFieldEnum.audience_reach],
    [MonitoringSortTypesEnum.relevancy, SearchCriteriaSortFieldEnum.relevancy],
    [MonitoringSortTypesEnum.domainAuthority, SearchCriteriaSortFieldEnum.domainAuthority],
    [MonitoringSortTypesEnum.engagement, SearchCriteriaSortFieldEnum.engagement_total],
    [MonitoringSortTypesEnum.engagement_rate, SearchCriteriaSortFieldEnum.engagement_rate],
]);
